import Axios from "@/utils/Axios";

/**
 * 获取历史隐患列表
 */
export function getRiskList(context) {
  let param = {};
  param.method = "get";
  param.url = "/monitorBoard/risk/history";
  param.params = {
    status: context.statius,
    showNum: context.riskpage,
    pageNum: context.nowpage,
    monitorSiteId: context.saveid,
    startTime: context.hissttm,
    endTime: context.hisedtm,
  }
  return Axios.ajax(param).then((res) => {
    if (res.data.dataList && res.data.dataList.length > 0){
      context.riskSum = res.data.totalNum;
      context.hisList = res.data.dataList;
      context.isHisList = true;
    } else {
      context.isHisList = false;
      console.log('没有数据',res)
    }
  })
}

/**
 * 获取隐患处理历史
 */
export function getRiskDeal(context, riskId) {
  context.riskId = riskId
  let param = {};
  param.method = "get";
  param.url = "/monitorBoard/risk/handleHistory";
  param.params = {
    riskId: riskId,
  }
  return Axios.ajax(param).then((res) => {
    context.dealList = res.data
  })
}

/**
 * 获取风险类型列表
 */
export function getRiskTypeList(context) {
  let param = {};
  param.method = "post";
  param.url = "/riskRecord/group";
  param.data = {
    monitorSiteId: context.saveid,
  }
  return Axios.ajax(param).then((res) => {
    context.riskTypeList = res.data
    if (res.data.length === 0){
      context.isRiskTypeList = false;
    }
  })
}

/**
 * 获取特定风险类型详情
 */
export function getRiskTypeAll(context) {
  let param = {};
  param.method = "post";
  param.url = "/riskRecord/page";
  param.data = {
    "alertLevel": context.alertLevel,
    "endTime": context.hisedtm2,
    "monitorId": context.saveid,
    "pageNum": context.nowpage1,
    "showNum": context.riskpage1,
    "startTime": context.hissttm2
  }
  return Axios.ajax(param).then((res) => {
    context.detailList = res.data.dataList
    context.riskSum1 = res.data.totalNum
  })
}

/**
 * 获取单个风险位置详情
 */
export function changeTitle(context, index, item) {
  context.activeTitle = index
  let param = {};
  param.method = "post";
  param.url = "/riskPosition/detail";
  param.data = {
    id: item.positionId,
  }
  return Axios.ajax(param).then((res) => {
    context.alertMessage = res.data.positionDesc
  })
}

/**
 * 获取风险位置列表
 */
export function getTitleList(context, alertLevel, mess) {
  let param = {};
  param.method = "post";
  param.url = "/riskPosition/monitorPositions";
  param.data = {
    monitorSiteId: context.saveid,
    alertLevel: alertLevel,
  }
  return Axios.ajax(param).then((res) => {
    context.titleList = res.data
    if (res.data.length) {
      changeTitle(context, 0, res.data[0])
    } else {
      context.alertMessage = mess
    }
  })
}

/**
 * 获取风险统计信息（月度）
 */
export function getRiskOne(context) {
  let param = {};
  param.method = "post";
  param.url = "/monitorBoard/risk/monthCount";
  param.data = {
    monitorSiteId: context.saveid,
  }
  return Axios.ajax(param).then((res) => {
    if (res.data) {
      context.greaterriskcount = res.data.greaterRiskCount
      context.significantriskcount = res.data.significantRiskCount
    }
  })
}

/**
 * 获取风险统计信息（总计）
 */
export function getRiskTwo(context) {
  let param = {};
  param.method = "post";
  param.url = "/monitorBoard/risk/count";
  param.data = {
    monitorSiteId: context.saveid,
  }
  return Axios.ajax(param).then((res) => {
    if (res.data) {
      context.thisMonthCount = res.data.thisMonthCount
      context.handledCount = res.data.handledCount
      context.unHandledCount = res.data.unHandledCount
    }
  })
}

/**
 * 获取风险列表
 */
export function getRiskThree(context) {
  let param = {};
  param.method = "post";
  param.url = "/monitorBoard/risk/list";
  param.data = {
    monitorSiteId: context.saveid,
  }
  return Axios.ajax(param).then((res) => {
    if (res.data) {
      context.risktable = res.data
    }
  })
}
